import { render, staticRenderFns } from "./ExaminationDialogV2.vue?vue&type=template&id=4a59ac71&scoped=true"
import script from "./ExaminationDialogV2.vue?vue&type=script&lang=js"
export * from "./ExaminationDialogV2.vue?vue&type=script&lang=js"
import style0 from "./ExaminationDialogV2.vue?vue&type=style&index=0&id=4a59ac71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a59ac71",
  null
  
)

export default component.exports